import { useMutation, useQueryClient } from 'react-query';
import {
  recoverPendingCancel,
  type RecoverPendingCancelResponse
} from '../../services/subscriptionService';

export function useRecoverPendingCancel() {
  const queryClient = useQueryClient();
  return useMutation<RecoverPendingCancelResponse, Error, { subscriptionId: string }>(
    ({ subscriptionId }) => recoverPendingCancel(subscriptionId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['mySubscription']);
      }
    }
  );
}
